import React from 'react'
import styled, { css } from 'styled-components'
import { func } from 'prop-types'
import { rgba } from 'polished'

import { fontWeights, fontSizes, fontFamily } from 'styles/typography'
import { animationTime, animationCurve } from 'styles/global'
import { borderColor, black, white, red } from 'styles/colors'
import * as spacing from 'styles/spacing'

export const SelectOption = styled.button`
  padding: ${spacing.small} ${spacing.large};
  text-align: center;
  background-color: ${rgba(borderColor, 0.75)};
  color: ${black};
  font-size: ${fontSizes.small};
  font-weight: ${fontWeights.medium};
  border-radius: ${spacing.xLarge};
  cursor: pointer;
  transition: all ${animationTime} ${animationCurve};

  &:hover {
    background-color: ${borderColor};
  }

  ${props =>
    props.selected &&
    css`
      background-color: ${black};
      color: ${white};
      box-shadow: inset 0 0 0 2px ${black};

      &:hover {
        background-color: ${black};
      }
    `}

  ${props =>
    props.isNew &&
    props.selected &&
    css`
      background-color: ${red};
      color: ${white};
      box-shadow: inset 0 0 0 2px ${red};

      &:hover {
        background-color: ${red};
      }
    `}
`

export const Font = styled.span`
  font-family: ${props => `${props.font}, ${fontFamily}`};
`

const ActionsContainer = styled.div`
  display: flex;
`

const ActionsItem = styled.button`
  font-size: ${fontSizes.tiny};
  font-weight: ${fontWeights.medium};

  &:first-child {
    border-right: 1px solid ${borderColor};
    padding-right: ${spacing.small};
    margin-right: ${spacing.small};
  }
`

export const EngravingActions = ({ onEdit, onRemove }) => (
  <ActionsContainer>
    <ActionsItem onClick={onEdit}>Edit</ActionsItem>
    <ActionsItem onClick={onRemove}>Remove</ActionsItem>
  </ActionsContainer>
)

EngravingActions.propTypes = {
  onEdit: func.isRequired,
  onRemove: func.isRequired
}
